import { createTheme, ThemeProvider } from "@material-ui/core";
import { Main } from "src/framework/layouts";
import { Loader, Confirmation } from "src/framework/components/commons";
import theme from "./theme/light";
import { appStore, doLoginContaUnica, doLogOut, getUserExtraData, isLoading$, isLoggedIn$, loginFromRedirect, notifierStore, validateLogin } from "src/framework/store";
import { Notifier } from "./framework/components/commons/dialogs";
import { ptBR } from "@material-ui/core/locale";
import Scrollbars from "react-custom-scrollbars-2";
import { useQuery } from "./framework/commons/useQuery";
import { useHistory } from "react-router-dom";
import { useObservable } from "./framework/store/storeUtil";
import "./App.css";
import { FC, useEffect } from "react";
import { LocalStorage } from "./framework/commons/LocalStorage";
import jwtDecode from "jwt-decode";
import { reaction } from "mobx";
import { WelcomePage } from "./pages/WelcomePage";
import { getBancos, getCartoesBandeiras, getDocumentosPagamentos, getFinanceiras, getFormasPagamentoTextoInformativo, getImageQrCodeFINAME } from "./store/global.store";
import { PedidoStore } from "./store/vendas/PedidoStore";
import { SessionStorage } from "./framework/commons";

const _theme = theme;
reaction(
  () => appStore.getError(),
  (error) => {
    const messages = Array.isArray(error) ? error : [error];

    notifierStore.setNotifier({
      content: error,
      title: "Aviso",
      timeOut: 2500,
      onClose: async () => {
        notifierStore.setOpen(false)

        if (messages.some((msg: string) => msg.includes("vigência") && msg.includes("encerrado"))) {
          const redirectURL = await doLogOut();
          if (redirectURL) {
              window.location.href = redirectURL
              LocalStorage.removeAll();
              SessionStorage.removeAll();
              isLoggedIn$.next(false);
          }
        }
      },
    });

    notifierStore.setOpen(true);
  }
);

const App: FC = () => {
  const isLoggedIn = useObservable(isLoggedIn$);
  const isLoading = useObservable(isLoading$)
  const query: any = useQuery();
  const history = useHistory();

  const onInit = () => {
    console.log("App init...")
    if (isLoggedIn) {
      getUserExtraData();
      getDocumentosPagamentos();
      getBancos();
      getFormasPagamentoTextoInformativo();
      getCartoesBandeiras();
      getFinanceiras();
      getImageQrCodeFINAME()
    }
  };

  const onExit = () => {
    console.log("Exiting app...")
  };

  if (!isLoggedIn) {
    validateLogin();
  }

  const resolveUrlPedido = (): any => {
    const urlPedido = query.get("pedido");
    const urlPedidoReduzido = query.get("p");

    // Pedido via V1 / e-mail
    if (urlPedido) {
      LocalStorage.set("solar.pedido", urlPedido);
      return urlPedido
    }
    
    // Pedido via link whatsapp
    if (urlPedidoReduzido) {
      const pedidoDecode = Buffer.from(decodeURIComponent(urlPedidoReduzido), "base64").toString();
      const objPedido = { codigo_venda: pedidoDecode }
      const hash = encodeURIComponent(Buffer.from(JSON.stringify(objPedido)).toString("base64"))
      LocalStorage.set("solar.pedido", hash);
      return hash
    }
    return null;
  }

  useEffect(() => {
    (async () => {
      console.log("Iniciando validação de login")
      if (!isLoggedIn) {
        try {
          isLoading$.next(true);
          const codeContaUnica = query.get("code");
          // const urlPage = query.get("page");
          const urlToken = query.get("token");
          const urlPedido = resolveUrlPedido()
          /**
           * 1 - Login com Conta Intelbras: No momento apenas usuário final
           */
          if (!!codeContaUnica) {
            const sessionState = query.get("session_state");
            const fullPath = `${window.location.origin}${history.location.pathname}`
            const tipoCliente = LocalStorage.get("tipoCliente") || null;
            await doLoginContaUnica(codeContaUnica, sessionState, fullPath, tipoCliente);
            LocalStorage.remove('tipoCliente')
          }

          let token = validateLogin();

          navigator.geolocation.getCurrentPosition(
            (_geo) => { },
            _error => {
              console.log("Permissão negada pelo usuário")
            }
          )

          /** 
           * 2 - Login via redirecioanmento: Pode ser proveniente da V1 quanto de urls passadas para os usuáruios via e-mail por exemple.
           * Nesse caso o usuário logado irá informar qual tipo de usuário é e efetuar o seu login correspondente - Keycloak 
           */
          if (urlToken) {
            isLoggedIn$.next(false);
            // LocalStorage.removeAll();
            const _token = String(urlToken || "")
            if (_token !== "") {
              await loginFromRedirect(_token)
              const decoded: any = jwtDecode(_token);
              LocalStorage.set("solar.cpfcnpj", decoded["cnpj_cpf"])
              getUserExtraData();
              const pedido = urlPedido || LocalStorage.get("solar.pedido");
              if (pedido) {
                const pedidoDecode = Buffer.from(decodeURIComponent(pedido), "base64").toString();
                const pedidoEvidente = JSON.parse(pedidoDecode);
                PedidoStore.setPedidoCodigoRedirect(pedidoEvidente.codigo_venda)
              }
            }
            history.push("/")
            return;
          }

          if (token) {
            isLoggedIn$.next(true);
            const pedido = LocalStorage.get("solar.pedido");
            if (pedido) {
              const pedidoDecode = Buffer.from(decodeURIComponent(pedido), "base64").toString();
              const pedidoEvidente = JSON.parse(pedidoDecode);
              PedidoStore.setPedidoCodigoRedirect(pedidoEvidente.codigo_venda)
            }
            // getUserExtraData();

            history.push("/")
            return;
          }

          // const redirect = await getUrlContaUnica();

          // if (redirect && !codeContaUnica) {
          //   window.location.href = redirect
          // }
          return;
        } catch (error) {

        } finally {
          console.log("Validação de login finalizada")
          isLoading$.next(false);
        }
      }
    })();

  }, [])


  return (
    <ThemeProvider theme={createTheme(_theme, ptBR)}>
      <Loader />
      <Confirmation />
      <Notifier />
      <div className="App">
        <fieldset disabled={isLoading} className="global-fieldset">
            {isLoggedIn ? (
              <Main onExit={() => onExit()} onInit={() => onInit()} />
              ) : (
                <WelcomePage />
              )}
        </fieldset>
      </div>
    </ThemeProvider>
  );
};

export default App;
